import { ReactElement } from 'react';
import { CustomViewEntity } from 'src/graphql/entities/custom-view';
import {
  ClientSelectedView,
  ConversationSelectedView,
  ProjectSelectedView,
  SiteSelectedView,
} from './views-by-entities';

export const SELECTED_VIEWS_BY_ENTITY: Partial<Record<CustomViewEntity, () => ReactElement>> =
  {
    conversation: ConversationSelectedView,
    site: SiteSelectedView,
    project: ProjectSelectedView,
    client: ClientSelectedView,
  };

export const CONVERSATIONS_VIEW_WRAPPER_STYLES = {
  height: '100%',
};
